import React from "react";
import styles from "./LoadingCircle.module.scss"; // Import SCSS module
import starLoader from "img/genai/StarLoader.svg";

export const LoaderEdt = () => {
  return (
    <>
      <div className={styles.loaderContainer}>
        <span>
          {/* <img src={starLoader} alt="loader" className={styles.strloader} /> */}
        </span>
        <div>
          <div className={styles.loaderLine}></div>
          <div className={styles.loaderLine}></div>
          <div className={styles.loaderLine}></div>
        </div>
      </div>
    </>
  );
};
